import { IMeetingArchive } from '../../resource/meeting-archives/meeting-archives.types';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import { ISession, ISessionEmail, ISessionSearchParams, ISessionUpdate } from '../../resource/session/session.types';
import { IApiRequestConfig } from '../api.types';

export const getNextSessionsApi = (searchParams: ISessionSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'nextSessions',
  uri: 'json',
  action: 'getNextSessions',
  method: 'get',
  params: searchParams,
});

export const getLastAndNextSessionsApi = (meetingId: IMeetingSimple['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'lastAndNextSessions',
  uri: 'json',
  action: `sessions/${meetingId}/last-and-next`,
  method: 'get',
  v2: true,
});

export const updateSessionApi = (sessionId: ISession['id'], data: ISessionUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateSession',
  uri: 'json',
  action: `sessions/${sessionId}`,
  method: 'patch',
  data,
  v2: true,
});

export const deleteSessionApi = (sessionId: ISession['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteSession',
  uri: 'json',
  action: `sessions/${sessionId}`,
  method: 'delete',
  v2: true,
});

export const saveEmailApi = (data: ISessionEmail): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveEmail',
  uri: 'json',
  action: 'saveEmail',
  method: 'post',
  data,
});

export const getMeetingArchiveApi = (meetingArchiveId: IMeetingArchive['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingArchive',
  uri: 'json',
  action: `sessions/${meetingArchiveId}/archive/`,
  method: 'get',
  v2: true,
});
